module.exports = __webpack_public_path__ + "static/img/tow.c258dff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/strawberryImg/tow.png
// module id = qCvx
// module chunks = 1